import React, {useEffect, useState} from 'react'
import PropTypes from "prop-types";
import PublicTournamentHighlightsTab from "./PublicTournamentHighlightsTab";
import {NavLink} from "react-router-dom";
import {NAVIGATION_ITEM} from "../../../../constants/navigationItems";
import {PrimeIcons} from "primereact/api";
import PublicTournamentStatistikTab from "./PublicTournamentStatistikTab";
import PublicTournamentParticipantTab from "./PublicTournamentParticipantTab";
import PublicTournamentRegistrationTab from "./PublicTournamentRegistrationTab";
import PublicTournamentTreeTab from "./PublicTournamentTreeTab";
import ConfigUtil from "../../../../util/ConfigUtil";
import FetchUtil from "../../../../util/FetchUtil";
import PublicTournamentGroupsTab from "./PublicTournamentGroupsTab";
import PublicTournamentLiveTab from "./PublicTournamentLiveTab";
import PublicTournamentDetailsTab from "./PublicTournamentDetailsTab";
import PublicTournamentKratzerGamesTab from "./PublicTournamentKratzerGamesTab";
import {Stomp} from "@stomp/stompjs";
import SockJS from "sockjs-client";
import RefreshButtonComp from "../../../RefreshButtonComp";
import PublicTournamentRanglisteTab from "./PublicTournamentRanglisteTab";
import PublicTournamentBreadCumb from "./PublicTournamentBreadCrumb";
import WebPushUtil from "../../../../util/WebPushUtil";
import ErrorInfoComponent from "../../../general/ErrorInfoComponent";
import PublicTournamentPlatzierungTab from "./PublicTournamentPlatzierungTab";
import PublicLigaspieltagGamesTab from "./PublicLigaspieltagGamesTab";
import {isGruppenturnier, TOURNAMENTSYSTEMS} from "../../../../constants/tournamentSystems";
import DHMobileDiv from "../../../general/DHMobileDiv";
import DHDesktopDiv from "../../../general/DHDesktopDiv";
import PublicTournamentLigaspieltagParticipantTab from "./PublicTournamentLigaspieltagParticipantTab";
import {addLastWatchedEvent, getFromLocalStorageWithDefault, getFromSessionStorageWithDefault, removeFromSessionStorage, saveToSessionStorage} from "../../../../util/localStorageZugriff";
import LastEventComp from "../../../LastEventComp";
import PublicLigaSpieltageTab from "./PublicLigaSpieltageTab";
import PublicLigaTabelleTab from "./PublicLigaTabelleTab";
import PublicAnyGamesTab from "./PublicAnyGamesTab";
import {Button} from "primereact/button";
import {ProgressSpinner} from "primereact/progressspinner";
import PublicLigaspielttagGastmannschaftInput from "../ligaspieltag/PublicLigaspielttagGastmannschaftInput";
import LigaspieltagEdartDetailStatisikArea from "../../tournament/LigaspieltagEdartDetailStatisikArea";
import {useMediaQuery} from "@mui/material";

let stompClient = undefined;

function PublicTournament({tournamentId, userId, isLoggedIn, appCall}) {

    const isMobile = useMediaQuery('(max-width:900px)');
    // Touch-Geräte (auch breite Tablets) vergrößern den Viewport, wenn die Seite breiter als der Bildschirm wird.
    const isTouch = useMediaQuery('(pointer: coarse)');

    const VIEW_NAME = "PublicTournament";
    const TAB_SESSION_STORAGE_KEY = "dh_tab_" + VIEW_NAME;

    const [errorMessage, setErrorMessage] = useState(undefined);

    const [errorLogMessages, setErrorLogMessages] = useState([]);
    const [errorLogClickCounter, setErrorLogClickCounter] = useState(0);

    const [autorefresh, setAutorefresh] = useState(true);

    const gastInputLigaspieltag = getFromLocalStorageWithDefault("dh_ligaspieltag_gast_input", undefined)
    const [showGasteingabeDialog, setShowGasteingabeDialog] = useState(false);

    const [tabValue, setTabValue] = useState(getFromSessionStorageWithDefault(TAB_SESSION_STORAGE_KEY, ""));
    const [liveGames, setLiveGames] = useState([]);
    const [tournamentWrapper, setTournamentWrapper] = useState(undefined);
    const [supportsWebPush, setSupportsWebPush] = useState(undefined);
    const [pushSpielerIds, setPushSpielerIds] = useState([]);

    useEffect(() => {
        if( !isMobile ) {
            return;
        }
        function handleEvent() {
            if( document.hidden) {
                setAutorefresh(false);
            } else {
                setAutorefresh(true);
            }
        }
        document.addEventListener("visibilitychange", handleEvent);

        return () => document.removeEventListener("visibilitychange", handleEvent);
    }, []);

    useEffect(() => {
        if( tournamentWrapper === undefined || tournamentWrapper.turnierMain === undefined) {
            return;
        }
        addLastWatchedEvent(tournamentWrapper.turnierMain.id, tournamentWrapper.turnierMain.bezeichnung);
    }, [tournamentWrapper]);

    useEffect(() => {
        if( autorefresh ) {
            connectStomp();
        } else {
            disconnectStomp();
        }
    }, [autorefresh]);

    useEffect(() => {
        return () => {
            removeFromSessionStorage(TAB_SESSION_STORAGE_KEY);
        };
    }, []);

    useEffect(() => {
        return () => {
            disconnectStomp();
        };
    }, []);

    useEffect(() => {
        saveToSessionStorage(TAB_SESSION_STORAGE_KEY, tabValue);
    }, [tabValue]);


    const connectStomp = () => {
        setErrorLogMessages(errorLogMessages => [...errorLogMessages, "connectStomp"]);
        stompClient = Stomp.over(function () {
            setErrorLogMessages(errorLogMessages => [...errorLogMessages, "URL: " + ConfigUtil.getConfig().websocketUrl]);
            return new SockJS(ConfigUtil.getConfig().websocketUrl);
        });
        stompClient.reconnect_delay = 10000;
        // stompClient.debug = function (str) {}; // Disable debug logging
        stompClient.connect({},
            (x) => {
                setErrorLogMessages(errorLogMessages => [...errorLogMessages, "Websocket - connect success"]);
                console.log("Websocket - connect success");
                const destination = "/topic/public/tournament/publicview/" + tournamentId;
                console.log("subscribe to " + destination);
                setErrorLogMessages(errorLogMessages => [...errorLogMessages, "subscribe to " + destination]);
                stompClient.subscribe(destination, (payload) => {
                    const body = JSON.parse(payload.body);
                    setTournamentWrapper(body);
                    setErrorLogMessages(errorLogMessages => [...errorLogMessages, "body: " + payload.body]);
                });

                const destinationLiveView = "/topic/public/tournament/game/infos/" + tournamentId;
                console.log("subscribe to " + destinationLiveView);
                setErrorLogMessages(errorLogMessages => [...errorLogMessages, "subscribe to " + destinationLiveView]);
                stompClient.subscribe(destinationLiveView, (payload) => {
                    const body = JSON.parse(payload.body);
                    setLiveGames(body.gameShortInfos);
                    setErrorLogMessages(errorLogMessages => [...errorLogMessages, "livegames body: " + payload.body]);
                });

            },
            (x) => {
                console.log("Websocket - connect error:", x);
                setErrorLogMessages(errorLogMessages => [...errorLogMessages, "Error: " + x]);
            },
            (x) => {
                console.log("Websocket - disconnect: ", x);
                setErrorLogMessages(errorLogMessages => [...errorLogMessages, "Websocket - disconnect: " + x]);
                setErrorLogMessages(errorLogMessages => [...errorLogMessages, "Websocket - disconnect: " + JSON.stringify(x)]);
            });
    }

    const disconnectStomp = () => {
        if( stompClient !== null && stompClient !== undefined) {
            console.log("Websocket 2 - disconnect:");
            setErrorLogMessages(errorLogMessages => [...errorLogMessages, "Websocket 2 - disconnect"]);
            stompClient.disconnect(() => {});
        }
    }

    useEffect(() => {
        ladeDaten(tournamentId);
    }, []);

    const ladeDaten = async (id) => {
        setErrorMessage(undefined);
        if (tournamentId === null || tournamentId === undefined) {
            return;
        }
        let url = ConfigUtil.getConfig().resourceUrls.public + "/tournament/" + id;
        FetchUtil.fetchGet(url,
            json => {
                setTournamentWrapper(json);
                if( json.turnierMain.tournamentstatus === "neu" && tabValue === "" && json.turnierMain.turniersystem !== TOURNAMENTSYSTEMS.LIGASPIELTAG.id ) {
                    setTabValue("anmeldung");
                } else if( tabValue === "") {
                    setTabValue("teilnehmer");
                }
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
            });

        const supportsWebPush = await WebPushUtil.check();
        setSupportsWebPush(supportsWebPush);
        if (supportsWebPush) {
            updateSubscriptions();
        }
    }

    const updateSubscriptions = () => {
        WebPushUtil.subscriptionsLaden(tournamentId,
            ok => {
                setPushSpielerIds(ok.spielerIds)
            });
    }

    const isLigaspieltagUndGasteingabe = () => {
        if( tournamentWrapper &&
            tournamentWrapper.turnierMain &&
            tournamentWrapper.turnierMain.turniersystem === TOURNAMENTSYSTEMS.LIGASPIELTAG.id) {
            return gastInputLigaspieltag && gastInputLigaspieltag.tournamentid === tournamentWrapper.turnierMain.id;
        }
        return false;
    }

    const erzeugeTab = (value, key, icon, width, color) => {
        return <div style={{color: "white", fontSize: 20, width: isMobile ? 40 : width,
            marginTop: 5,
            marginLeft:5, cursor:"pointer",
            borderBottom: tabValue === key ? "2px solid red" : "none", textAlign:"center"}}
                    onClick={() => setTabValue(key)}>

            <i className={icon}
               style={{fontSize: 20, marginLeft: 5, marginRight: 5, color: color ? color : "white", cursor: "pointer"}}/><br/>
            {!isMobile && value.toUpperCase()}
        </div>
    }

    const isShowPlatzierung = () => {
        let isNotNew = tournamentWrapper.turnierMain.tournamentstatus !== "neu"
        let isGruppenturnier = tournamentWrapper.turnierMain.turniersystem === TOURNAMENTSYSTEMS.GRUPPE_DANN_DKO.id ||
            tournamentWrapper.turnierMain.turniersystem === TOURNAMENTSYSTEMS.GRUPPE_DANN_KO.id;
        let isKOoderDKO = tournamentWrapper.turnierMain.turniersystem === TOURNAMENTSYSTEMS.DOPPELTERKO.id ||
            tournamentWrapper.turnierMain.turniersystem === TOURNAMENTSYSTEMS.EINFACHERKO.id;
        let isSchweizerSystem = tournamentWrapper.turnierMain.turniersystem === TOURNAMENTSYSTEMS.SCHWEIZERSYSTEM.id;
        return isNotNew && (isGruppenturnier || isKOoderDKO || isSchweizerSystem);
    }

    const isSchweizerSystem = () => {
        return tournamentWrapper.turnierMain.turniersystem === TOURNAMENTSYSTEMS.SCHWEIZERSYSTEM.id;
    }

    const isEdartDetailStatistik = () => {
        return tournamentWrapper.turnierMain.edartDetailStatistik
    }

    const getTabs = () => {
        let returnValue = [];
        if( tournamentWrapper.turnierMain.tournamentstatus === "neu" && tournamentWrapper.turnierMain.turniersystem !== TOURNAMENTSYSTEMS.LIGASPIELTAG.id ) {
            returnValue.push(erzeugeTab("Anmeldung" ,"anmeldung", PrimeIcons.PLUS, 160));
        }
        returnValue.push(erzeugeTab("Teilnehmer", "teilnehmer", PrimeIcons.USER, 160));
        if( tournamentWrapper.turnierMain.tournamentstatus !== "neu") {
            if (tournamentWrapper.turnierMain.turniersystem === TOURNAMENTSYSTEMS.LIGASPIELTAG.id) {
                returnValue.push(erzeugeTab("Games", "ligaspieltaggames", PrimeIcons.TH_LARGE, 160));
            }
            if (tournamentWrapper.turnierMain.turniersystem === TOURNAMENTSYSTEMS.ANY_GAMES.id) {
                returnValue.push(erzeugeTab("Games", "anygames", PrimeIcons.TH_LARGE, 160));
            }
            if (tournamentWrapper.turnierMain.turniersystem === TOURNAMENTSYSTEMS.LIGA.id) {
                returnValue.push(erzeugeTab("Spieltage", "ligaspieltage", PrimeIcons.TH_LARGE, 160));
            }
            if (tournamentWrapper.turnierMain.turniersystem === TOURNAMENTSYSTEMS.LIGA.id) {
                returnValue.push(erzeugeTab("Tabelle", "ligatabelle", PrimeIcons.TH_LARGE, 160));
            }
            if( tournamentWrapper.turnierGruppe !== null && tournamentWrapper.turnierKO !== undefined) {
                returnValue.push(erzeugeTab(isSchweizerSystem() ? "Runden" : "Gruppen", "gruppen", PrimeIcons.TH_LARGE, 160));
            }
            if( tournamentWrapper.turnierKO !== null && tournamentWrapper.turnierKO !== undefined) {
                let bez =  isGruppenturnier(tournamentWrapper.turnierMain.turniersystem) ? tournamentWrapper.turnierKO.bezeichnung : "KO/DKO";
                returnValue.push(erzeugeTab(bez,"baum", PrimeIcons.SHARE_ALT, 160, tournamentWrapper.turnierSilber ? "gold" : undefined));
            }
            if( tournamentWrapper.turnierSilber !== null && tournamentWrapper.turnierSilber !== undefined) {
                returnValue.push(erzeugeTab(tournamentWrapper.turnierSilber.bezeichnung,"silberturnier", PrimeIcons.SHARE_ALT, 160, "silver"));
            }
            if( tournamentWrapper.turnierBronze !== null && tournamentWrapper.turnierBronze !== undefined) {
                returnValue.push(erzeugeTab(tournamentWrapper.turnierBronze.bezeichnung,"bronzeturnier", PrimeIcons.SHARE_ALT, 160, "sienna"));
            }
            if( tournamentWrapper.kratzerDto !== null && tournamentWrapper.kratzerDto !== undefined) {
                returnValue.push(erzeugeTab("Games","kratzergames", PrimeIcons.TH_LARGE, 160));
            }
            if( tournamentWrapper.turnierMain.scoringWithDarthelfer) {
                returnValue.push(erzeugeTab("Highlights","highlights", PrimeIcons.CHART_BAR, 160));
                returnValue.push(erzeugeTab("Statistik","statistik", PrimeIcons.CHART_LINE, 160));
            }
            if( isEdartDetailStatistik() ) {
                returnValue.push(erzeugeTab("Statistik","edartstatistik", PrimeIcons.CHART_BAR, 160));
            }
        }
        if( isShowPlatzierung()) {
            returnValue.push(erzeugeTab("Platzierung","platzierung", PrimeIcons.STAR_FILL, 180));
        }
        if( tournamentWrapper.turnierMain.tournamentstatus === "abgeschlossen" && (tournamentWrapper.turnierMain.rangliste || (tournamentWrapper.turnierMain.ranglisteId !== null && tournamentWrapper.turnierMain.ranglisteId !== undefined))) {
            returnValue.push(erzeugeTab("Rangliste","rangliste", PrimeIcons.STAR, 160));
        }
        if( tournamentWrapper.turnierMain.tournamentstatus === "gestartet" && tournamentWrapper.turnierMain.scoringWithDarthelfer) {
            returnValue.push(erzeugeTab("Live","live", PrimeIcons.EYE, 160));
        }
        returnValue.push(erzeugeTab("Details","details", PrimeIcons.FOLDER_OPEN, 160));
        if( !isMobile) {
            returnValue.push(<RefreshButtonComp text="Auto" autorefresh={autorefresh} onRefresh={() => ladeDaten(tournamentId)} shutdownminutes={600}
                                                onAutoRefresh={(schalter) => {
                                                    setAutorefresh(schalter);
                                                }}/>);
        }
        return returnValue;
    }

    const isUserTeilnehmer = () => {
        if (userId === undefined || userId === null) {
            return false;
        }
        for (const player of tournamentWrapper.turnierMain.tournamentPlayerEntities) {
            if( player.userId === userId ) {
                return true;
            }
        }
        return false;
    }

    const getTabpanel = () => {
        if( tabValue === "anmeldung" ) {
            return <div className="darthelfer-background-blue">
                <PublicTournamentRegistrationTab userId={userId} eventOperatorId={tournamentWrapper.turnierMain.eventOperatorId} isLoggedIn={isLoggedIn} isUserTeilnehmer={isUserTeilnehmer()}
                                                 tournamentId={tournamentWrapper.turnierMain.id}
                                                 maxAnzahlTeilnehmer={tournamentWrapper.turnierMain.maxAnzahlTeilnehmer}
                                                 anzahlTeilnehmer={tournamentWrapper.turnierMain.tournamentPlayerEntities.length}
                                                 isDoppelturnier={tournamentWrapper.turnierMain.doppelturnier}
                                                 isDYP={tournamentWrapper.turnierMain.dyp}
                                                 registrationAllowed={tournamentWrapper.turnierMain.registrationAllowed} isParticipantsMailConfirmation={tournamentWrapper.turnierMain.participantsMailConfirmation} passwordRequired={tournamentWrapper.turnierMain.kennwort !== null && tournamentWrapper.turnierMain.kennwort !== undefined && tournamentWrapper.turnierMain.kennwort !== ""} onRefresh={() => ladeDaten(tournamentId)}/>
            </div>
        } else if( tabValue === "teilnehmer" ) {
            if( tournamentWrapper.turnierMain.turniersystem === TOURNAMENTSYSTEMS.LIGASPIELTAG.id) {
                return <div className="darthelfer-background-blue">
                    <PublicTournamentLigaspieltagParticipantTab tournamentId={tournamentWrapper.turnierMain.id}
                                                    participants={tournamentWrapper.turnierMain.tournamentPlayerEntities}/>
                </div>
            }
            return <div className="darthelfer-background-blue">
                <PublicTournamentParticipantTab tournamentId={tournamentWrapper.turnierMain.id}
                                                tournamentGroupEntities={tournamentWrapper.turnierMain.tournamentGroupEntities}
                                                maxAnzahlTeilnehmer={tournamentWrapper.turnierMain.maxAnzahlTeilnehmer}
                                                participants={tournamentWrapper.turnierMain.tournamentPlayerEntities}
                                                playersSortedByTime={tournamentWrapper.turnierMain.playersSortedByTime}
                                                isBezahlung={tournamentWrapper.turnierMain.bezahlung} isParticipantsMailConfirmation={tournamentWrapper.turnierMain.participantsMailConfirmation}
                                                supportsWebPush={supportsWebPush} pushSpielerIds={pushSpielerIds} updateSubscriptions={updateSubscriptions} />
            </div>
        }
        else if( tabValue === "ligaspieltaggames" ) {
            return <div className="darthelfer-background-blue">
                <PublicLigaspieltagGamesTab tournament={tournamentWrapper.turnierMain}
                                            liveGames={liveGames}
                                            boardGames={tournamentWrapper.boardGames}/>
            </div>
        }
        else if( tabValue === "anygames" ) {
            return <div className="darthelfer-background-blue">
                <PublicAnyGamesTab tournament={tournamentWrapper.turnierMain} games={tournamentWrapper.tournamentAnyGames} boardGames={tournamentWrapper.boardGames}/>
            </div>
        } else if( tabValue === "ligaspieltage" ) {
            return <div className="darthelfer-background-blue">
                <PublicLigaSpieltageTab tournament={tournamentWrapper.turnierMain} boardGames={tournamentWrapper.boardGames}/>
            </div>
        } else if( tabValue === "ligatabelle" ) {
            return <div className="darthelfer-background-blue">
                <PublicLigaTabelleTab tournament={tournamentWrapper.turnierMain} gruppenTabellen={tournamentWrapper.gruppenTabellen}/>
            </div>
        }
        else if( tabValue === "rangliste" ) {
            return <div className="darthelfer-background-blue">
                <PublicTournamentRanglisteTab participants={tournamentWrapper.turnierMain.tournamentPlayerEntities}
                                              eventOperatorId={tournamentWrapper.turnierMain.eventOperatorId}
                                              rankingId={tournamentWrapper.turnierMain.ranglisteId}/>
            </div>
        }
        else if( tabValue === "platzierung" ) {
            return <div className="darthelfer-background-blue">
                <PublicTournamentPlatzierungTab tournamentId={tournamentWrapper.turnierMain.id}/>
            </div>
        } else if( tabValue === "gruppen" ) {
            return <div className="darthelfer-background-blue">
                <PublicTournamentGroupsTab tournament={tournamentWrapper.turnierGruppe} tournamentWrapper={tournamentWrapper} gruppenTabellen={tournamentWrapper.gruppenTabellen}
                                           bestplatzierteDtos={tournamentWrapper.bestplatzierteDtos}
                                           boardGames={tournamentWrapper.boardGames}
                                           liveGames={liveGames}
                                           gruppeModelWrapperListe={tournamentWrapper.gruppeModelWrapperListe}
                />
            </div>
        } else if( tabValue === "baum" ) {
            return <div className="darthelfer-background-blue">
                <PublicTournamentTreeTab tournament={tournamentWrapper.turnierKO}
                                         model={tournamentWrapper.modelKO}
                                         boardGames={tournamentWrapper.boardGames}
                                         liveGames={liveGames}
                                         boardReihenfolge={tournamentWrapper.boardReihenfolgeKO}
                                         tournamentBeschreibungen={tournamentWrapper.tournamentBeschreibungenKO}/>
            </div>
        } else if( tabValue === "silberturnier" ) {
            return <div className="darthelfer-background-blue">
                <PublicTournamentTreeTab tournament={tournamentWrapper.turnierSilber} model={tournamentWrapper.modelTurnierSilber}
                                         liveGames={liveGames}
                                         boardGames={tournamentWrapper.boardGames} boardReihenfolge={tournamentWrapper.boardReihenfolgeSilberTurnier}
                                         tournamentBeschreibungen={tournamentWrapper.tournamentBeschreibungenSilberTurnier}/>
            </div>
        } else if( tabValue === "bronzeturnier" ) {
            return <div className="darthelfer-background-blue">
                <PublicTournamentTreeTab tournament={tournamentWrapper.turnierBronze} model={tournamentWrapper.modelTurnierBronze}
                                         liveGames={liveGames}
                                         boardGames={tournamentWrapper.boardGames} boardReihenfolge={tournamentWrapper.boardReihenfolgeBronzeTurnier}
                                         tournamentBeschreibungen={tournamentWrapper.tournamentBeschreibungenBronzeTurnier}/>
            </div>
        } else if( tabValue === "kratzergames" ) {
            return <div className="darthelfer-background-blue">
                <PublicTournamentKratzerGamesTab tournament={tournamentWrapper.turnierMain}
                                                 aktuelleRunde={tournamentWrapper.kratzerDto.aktuelleRunde} gewinnerPlayerId={tournamentWrapper.kratzerDto.gewinnerPlayerId}
                                                 tournamentPlayers={tournamentWrapper.turnierMain.tournamentPlayerEntities}
                                                 tournamentKratzerGames={tournamentWrapper.kratzerDto.tournamentKratzerGameEntities}
                                                 tournamentKratzerGamePlayers={tournamentWrapper.kratzerDto.tournamentKratzerGamePlayerEntities}
                                                 restpunkteDtos={tournamentWrapper.kratzerDto.restpunkteDtos} onCallbackReload={() => ladeDaten(tournamentId)}/>
            </div>
        } else if( tabValue === "highlights" ) {
            return <div className="darthelfer-background-blue">
                <PublicTournamentHighlightsTab tournament={tournamentWrapper}/>
            </div>
        } else if( tabValue === "statistik" ) {
            return <div className="darthelfer-background-blue">
                <PublicTournamentStatistikTab tournamentId={tournamentWrapper.turnierMain.id} participants={tournamentWrapper.turnierMain.tournamentPlayerEntities}
                                              gesamtStatistik={tournamentWrapper.ranglisteWrapper.statistikDto} playerStatistiks={tournamentWrapper.ranglisteWrapper.playerStatistiks}/>
            </div>
        } else if( tabValue === "live" ) {
            return <div className="darthelfer-background-blue">
                <PublicTournamentLiveTab appCall={appCall} tournamentId={tournamentWrapper.turnierMain.id} tournamentBezeichnung={tournamentWrapper.turnierMain.bezeichnung} eventOperatorId={tournamentWrapper.turnierMain.eventOperatorId}/>
            </div>
        } else if( tabValue === "details" ) {
            return <div className="darthelfer-background-blue">
                {errorLogClickCounter > 10 && <div style={{color:"red"}}>Errorlogging ist an!! {errorLogClickCounter}</div>}
                <PublicTournamentDetailsTab tournament={tournamentWrapper.turnierMain} onDetailsClick={() => setErrorLogClickCounter(errorLogClickCounter + 1)} />
            </div>
        } else if (tabValue === "edartstatistik") {
            return <div className="darthelfer-background-blue">
                <LigaspieltagEdartDetailStatisikArea tournamentId={tournamentWrapper.turnierMain.id} players={tournamentWrapper.turnierMain.tournamentPlayerEntities}
                                                     games={tournamentWrapper.turnierMain.tournamentLeagueGameEntities} publicView={true}/>
            </div>
        }
    }

    const getErrorLogAresa = () => {
        let rows= [];
        for (const errorLogMessage of errorLogMessages) {
            rows.push(<div>{errorLogMessage}</div>);
        }
        return <div style={{marginTop:30, color:"red"}}>
            {rows}
        </div>
    }


    if( tournamentWrapper === undefined) {
        return <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
            <ErrorInfoComponent infoMessage={undefined} errorMessage={errorMessage} onClearInfoMessage={() => ""}
                                onClearErrorMessage={() => setErrorMessage(undefined)}/>
            <ProgressSpinner style={{width:100, height:100}}/>
        </div>
    }

    return <div style={{padding: 0, backgroundColor: "#022836", minHeight: "100vh", height: "100%", minWidth: "100%", width: isMobile || isTouch ? "100%" : "fit-content"}}>
        {/* Der Kopfbereich darf die Seitenbreite nicht bestimmen, sonst wird die Seite durch die Tabs breiter als der Bildschirm.
            Er passt sich aber der Seitenbreite an, wenn z.B. der Turnierbaum die Seite verbreitert. */}
        <div style={{contain: "inline-size"}}>
            <DHMobileDiv comp={
                <div style={{backgroundColor: "#022836"}}>
                    {!appCall &&
                        <PublicTournamentBreadCumb isMobil={true} isLiveView={false} tournamentBezeichnung={tournamentWrapper.turnierMain.bezeichnung}
                                                   eventOperatorId={tournamentWrapper.turnierMain.eventOperatorId} eventOperatorBezeichnung={tournamentWrapper.eventOperatorBezeichnung}
                                                   tournamentId={tournamentWrapper.turnierMain.id}/>
                    }
                    <hr style={{marginTop: 0, marginBottom: 0}}/>
                    <div style={{paddingLeft: 10, color: "black", fontSize: 20, backgroundColor: "white"}}>
                        {tournamentWrapper.turnierMain.bezeichnung}
                    </div>
                    {!appCall &&
                        <div style={{display: "flex", backgroundColor: "#022836"}}>
                            <NavLink to={NAVIGATION_ITEM.PUBLIC_TOURNAMENTS.route} style={{textDecoration: "none"}}>
                                <img alt="Logo" src={"/images/darthelfer_quer_weiss.png"} style={{height: 50, margin: 10}}/>
                            </NavLink>
                        </div>
                    }
                    {appCall &&
                        <div style={{display: "flex", backgroundColor: "#022836"}}>
                            <img alt="Logo" src={"/images/darthelfer_quer_weiss.png"} style={{height: 50, margin: 10}}/>
                        </div>
                    }
                </div>

            }/>
            <DHDesktopDiv comp={
                <>
                    {!appCall &&
                        <div style={{width: "100%"}}>
                            <PublicTournamentBreadCumb isMobil={false} isLiveView={false} tournamentBezeichnung={tournamentWrapper.turnierMain.bezeichnung}
                                                       eventOperatorId={tournamentWrapper.turnierMain.eventOperatorId} eventOperatorBezeichnung={tournamentWrapper.eventOperatorBezeichnung}
                                                       tournamentId={tournamentWrapper.turnierMain.id}/>
                        </div>
                    }
                    <hr style={{marginTop:0,marginBottom:0}}/>
                    <div style={{paddingLeft: 20, backgroundColor: "white", color: "black", fontSize: "2em"}}>
                        {tournamentWrapper.turnierMain.bezeichnung}
                    </div>
                </>
            }/>
            {!appCall &&
                <LastEventComp currentId={tournamentWrapper.turnierMain.id} onLoad={(id) => ladeDaten(id)}/>
            }
            { isLigaspieltagUndGasteingabe() && <div className="darthelfer-background-blue" style={{padding:10}}><Button label="Gasteingabe" onClick={() => setShowGasteingabeDialog(true)}/> </div>}
            <div style={{paddingTop: 10, paddingBottom:20, backgroundColor: "#022836"}}>
                <div style={{display: "flex", flexWrap: isMobile ? "wrap"  : "nowrap"}}>
                    {getTabs()}
                </div>
            </div>
        </div>
        {getTabpanel()}

        {showGasteingabeDialog && <PublicLigaspielttagGastmannschaftInput
            aktuellerBereich={tournamentWrapper.turnierMain.ligaspieltagBereich}
            onRefresh={() => ladeDaten(tournamentWrapper.turnierMain.id)}
            onClose={() => setShowGasteingabeDialog(false)}/> }

        {errorLogClickCounter > 10 && getErrorLogAresa()}
    </div>
}

PublicTournament.propTypes = {
    userId: PropTypes.string,
    isLoggedIn: PropTypes.bool.isRequired,
    tournamentId: PropTypes.string.isRequired,
};

export default PublicTournament;
